import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = ({
    data,
    menuOpen,
    setMenuOpen,
    darkMode,
    setDarkMode,
}) => {


    const {
        profile = {},
    } = data || {};


    const location = useLocation();

    useEffect(() => {
        document.body.style.overflow = menuOpen
            ? "hidden"
            : "";

        return () => {
            document.body.style.overflow = "";
        };
    }, [menuOpen]);


    const closeMenu = () => {
        setMenuOpen(false);
    };


    /*
    |--------------------------------------------------------------------------
    | Navigation
    |--------------------------------------------------------------------------
    */

    const navigation = [
        ["Home", "/"],
        ["About", "/about"],
        ["Career Timeline", "/careertimeline"],
        ["Constituency", "/constituency"],
        ["Projects", "/projects"],
        ["News", "/news"],
        ["Media", "/media"],


    ];


    /*
    |--------------------------------------------------------------------------
    | Handle navigation
    |--------------------------------------------------------------------------
    */

    const handleNavigation = (path) => {

        closeMenu();

        /*
         * If the user clicks a route they are already on,
         * scroll to the top.
         */
        if (location.pathname === path) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };


    return (
        <>
            {/* =====================================================
                TOP BAR
            ===================================================== */}

            <div
                className="top-bar"
                role="banner"
            >

                <div className="container top-bar-inner">

                    <span>
                        Official Website of{" "}
                        {profile.full_name ? <strong>{profile.full_name}</strong> : "Loading..."}
                    </span>


                    <div className="top-links">

                        <Link
                            to="/news"
                            onClick={closeMenu}
                        >
                            News &amp; Updates
                        </Link>


                        <Link
                            to="/contact"
                            onClick={closeMenu}
                        >
                            Contact Office
                        </Link>

                    </div>

                </div>

            </div>


            {/* =====================================================
                MAIN HEADER
            ===================================================== */}

            <header className="main-header">

                <div className="container nav-container">


                    {/* =================================================
                        BRAND
                    ================================================= */}

                    <Link
                        to="/"
                        className="brand"
                        onClick={() => {
                            closeMenu();

                            if (location.pathname === "/") {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                            }
                        }}
                        aria-label={`${profile.full_name ? profile.full_name : "Loading..."} home`}
                    >

                        <div
                            className="brand-mark"
                            aria-hidden="true"
                        >
                            <span>
                                {profile.initials ? <strong>{profile.initials}</strong> : "Loading..."}
                            </span>
                        </div>


                        <div className="brand-text">

                            <strong>
                                {profile.title ? <strong>{profile.title}</strong> : "Loading..."}{" "}
                                {profile.first_name ? profile.first_name.toUpperCase() : "Loading..."}
                            </strong>

                            <small>
                                {profile.middle_name ? profile.middle_name.toUpperCase() : "Loading..."}{" "}
                                {profile.last_name ? profile.last_name.toUpperCase() : "Loading..."}
                            </small>

                        </div>

                    </Link>


                    {/* =================================================
                        MOBILE MENU BUTTON
                    ================================================= */}

                    <button
                        className={`menu-toggle ${menuOpen ? "active" : ""
                            }`}
                        type="button"
                        onClick={() =>
                            setMenuOpen((v) => !v)
                        }
                        aria-expanded={menuOpen}
                        aria-controls="site-navigation"
                        aria-label={
                            menuOpen
                                ? "Close navigation menu"
                                : "Open navigation menu"
                        }
                    >

                        <span />
                        <span />
                        <span />

                    </button>


                    {/* =================================================
                        NAVIGATION
                    ================================================= */}

                    <nav
                        id="site-navigation"
                        className={`desktop-nav ${menuOpen
                                ? "mobile-active"
                                : ""
                            }`}
                        aria-label="Main navigation"
                    >


                        {/* Mobile close button */}

                        <div className="mobile-header">

                            <button style={{ color: "red" }}
                                type="button"
                                onClick={closeMenu}
                                aria-label="Close navigation"
                            >
                                ×
                            </button>

                        </div>


                        {/* Navigation */}

                        {navigation.map(
                            ([label, path]) => (

                                <Link
                                    key={path}
                                    to={path}
                                    onClick={() =>
                                        handleNavigation(path)
                                    }
                                    className={
                                        location.pathname === path
                                            ? "active"
                                            : ""
                                    }
                                >
                                    {label}
                                </Link>

                            )
                        )}


                        {/* Contact CTA */}

                        <Link
                            to="/contact"
                            className="nav-cta"
                            onClick={closeMenu}
                        >
                            Contact Office
                        </Link>


                        {/* Theme */}

                        <button style={{ display: "none" }}
                            type="button"
                            className="theme-toggle"
                            onClick={() =>
                                setDarkMode(
                                    (v) => !v
                                )
                            }
                            aria-label={
                                darkMode
                                    ? "Switch to light mode"
                                    : "Switch to dark mode"
                            }
                            aria-pressed={darkMode}
                        >

                            <span aria-hidden="true">
                                {darkMode
                                    ? "☀"
                                    : "◐"}
                            </span>

                            <span>
                                {darkMode
                                    ? "Light mode"
                                    : "Dark mode"}
                            </span>

                        </button>

                    </nav>

                </div>

            </header>
        </>
    );
};

export default Header;

